import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-300">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-flight-takeoff-line" aria-hidden="true"></i>
              </span>
              <span className="text-background-50 font-heading font-bold text-lg">诱人的飞行</span>
            </div>
            <p className="text-sm leading-relaxed text-background-400">
              一个专注电影与电视剧的内容平台，为你整理最新影视内容、剧情介绍与行业资讯，帮你更快找到想看的那一部。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-medium mb-4 text-sm">
              <Link to="/category?type=movie" className="hover:text-accent-400 transition-colors">
                浏览内容
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/category?type=movie" className="hover:text-accent-400 transition-colors">电影分类</Link></li>
              <li><Link to="/category?type=tv" className="hover:text-accent-400 transition-colors">电视剧分类</Link></li>
              <li><Link to="/special" className="hover:text-accent-400 transition-colors">影视专题</Link></li>
              <li><Link to="/news" className="hover:text-accent-400 transition-colors">影视资讯</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-medium mb-4 text-sm">
              <Link to="/about" className="hover:text-accent-400 transition-colors">
                关于我们
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">网站定位</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">团队介绍</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">联系方式</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-medium mb-4 text-sm">友情链接</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="https://www.themoviedb.org/" target="_blank" rel="noopener noreferrer" className="hover:text-accent-400 transition-colors">影视资料库</a></li>
              <li><a href="https://www.imdb.com/" target="_blank" rel="noopener noreferrer" className="hover:text-accent-400 transition-colors">影片信息参考</a></li>
              <li><a href="https://readdy.ai" target="_blank" rel="noopener noreferrer" className="hover:text-accent-400 transition-colors">技术支持</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 诱人的飞行 · 本站内容为结构演示，影视资料均为原创示例</p>
          <p>不提供影片播放与下载功能</p>
        </div>
      </div>
    </footer>
  );
}